import React from 'react';
import PropTypes from 'prop-types';
import {Download32} from '@carbon/icons-react';
import { ExportToCsv } from 'export-to-csv';
import { Button } from 'carbon-components-react';
import * as DashboardConstants from '../components/Dashboards/DashboardConstants'

const options = {
  fieldSeparator: ',',
  quoteStrings: '"',
  decimalSeparator: '.',
  showLabels: true,
  useTextFile: false,
  useBom: true,
};

const TableToolbarDownload = ({ headers, rows, title, filename, label,iconDescription }) => {
  const csvRows = rows.map(row => {
    const newRow = {};
    headers.forEach(({ key }) => {
      newRow[key] = row[key] ? row[key] : '';
    });
    return newRow;
  });

  if (title) {
    options.showTitle = true;
    options.title = title;
  }
  options.filename = filename;

  options.headers = headers.map(({ header }) => header);

  const csvExporter = new ExportToCsv(options);

  return (
    <Button
      size="lg"
      renderIcon={Download32}
      kind='ghost'
      iconDescription={iconDescription} 
      label={label}
      style={{color: '#161616', 'margin-right': '5px'}}
      onClick={() => {
        if (rows.length > 0 && headers.length > 0)
          csvExporter.generateCsv(csvRows);
      }}
    />
  );
};

TableToolbarDownload.propTypes = {
  /**
   * @type {Object.<Object, *>}
   * The `rows` prop is where you provide us with a list of all the rows that
   * you want to render in the table. The only hard requirement is that this
   * is an array of objects, and that each object has a unique `id` field
   * available on it.
   */
  rows: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
    })
  ).isRequired,

  /**
   * @type {Object.<Object, *>}
   * The `headers` prop represents the order in which the headers should
   * appear in the table. We expect an array of objects to be passed in, where
   * `key` is the name of the key in a row object, and `header` is the name of
   * the header.
   */
  headers: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      header: PropTypes.string.isRequired,
    })
  ).isRequired,

  /** @type {string} the title used for the generated CSV table */
  title: PropTypes.string,

  /** @type {string} the filename used for the generated CSV file */
  filename: PropTypes.string,

  /** @type {string} the aria-label for the button */
  label: PropTypes.string,
};

TableToolbarDownload.defaultProps = {
  title: '',
  filename: DashboardConstants.DataTable,
  label: DashboardConstants.Download,
};

export default TableToolbarDownload;